import { Form } from '@chilipiper/api-type-def'
import { del, get, post } from './api'

export interface CreatePersonalWorkspaceFormPayload {
  type: 'Uid'
  userId: string
}

export interface CreateWorkspaceFormPayload {
  type: 'Wid'
  workspaceId: string
}

export const form = {
  byId(id: string) {
    return get(`online/form/${id}`).json<Form>()
  },
  getAll(meetingId: string) {
    return get(`online/forms/list/${meetingId}`).json<Form[]>()
  },
  getAllByUser() {
    return get(`online/forms/list-all/user`).json<Form[]>()
  },
  save(form: Form) {
    return post(`online/forms/save`, {
      json: form,
    }).json<Form>()
  },
  delete(id: string) {
    return del(`online/form/${id}`).json<Form>()
  },
  async create(payload: CreatePersonalWorkspaceFormPayload | CreateWorkspaceFormPayload) {
    return post('online/forms/create', {
      json: payload,
    }).json<Form>()
  },
}
